import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer" id="footer">
      <div className="footer-container">
        <div className="footer-section">
          <div className="section-title">
            <span className="title-line"></span>
            <h3>Policies</h3>
          </div>
          <div className="footer-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/cookies">Cookie Policy</Link>
          </div>
        </div>

        <div className="footer-section">
          <div className="section-title">
            <span className="title-line"></span>
            <h3>Contact Us</h3>
          </div>
          <div className="footer-links">
            <a href="https://forms.gle/KwPbb5GEfBE56xxz8" target="_blank" rel="noopener noreferrer">Support Form</a>
            <a href="mailto:admin@seemuseums.art">admin@seemuseums.art</a>
            <a href="https://discord.gg/aCXZjNp9WF" target="_blank" rel="noopener noreferrer">Join our Discord</a>
          </div>
        </div>

        <div className="footer-section">
          <div className="section-title">
            <span className="title-line"></span>
            <h3>Follow Us</h3>
          </div>
          <div className="social-icons">
            <a href="https://www.linkedin.com/company/seemuseums/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="fa-brands fa-linkedin"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fa-brands fa-instagram"></i>
            </a>
            <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <i className="fa-brands fa-tiktok"></i>
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <i className="fa-brands fa-youtube"></i>
            </a>
            <a href="https://discord.gg/aCXZjNp9WF" target="_blank" rel="noopener noreferrer" aria-label="Discord">
              <i className="fa-brands fa-discord"></i>
            </a>
          </div>
        </div>
      </div>
      
      <div className="copyright">
        &copy; 2025 SeeM Inc. All Rights Reserved
      </div>
    </footer>
  );
};

export default Footer; 